module.exports = __webpack_public_path__ + "static/food-9518842c080b99b129c3c1901b238a8a.png";